import React from 'react';
import SearchableSelect from './SearchableSelect';
import { COUNTRIES } from '../../utils/countries';

const CountrySelect = ({
    value,
    onChange,
    label = 'Country',
    error,
    required = false,
    placeholder = 'Select country',
    className = '',
    disabled = false
}) => {
    return (
        <SearchableSelect
            label={label}
            options={COUNTRIES}
            value={value}
            onChange={onChange}
            error={error}
            required={required}
            placeholder={placeholder}
            className={className}
            disabled={disabled}
        />
    );
};

export default CountrySelect;
